import { useGlobalContext, useIoContext, useStoreActions } from "../contexts";
import { sendErrReport, handlePromise } from "../infra/utils";
import { routes } from "../constants";
import { useOpenCopyLinkModal } from "./useOpenCopyLinkModal";
export function useCopyAgreementLink() {
  const globalContext = useGlobalContext();
  const {
    api,
    logBI
  } = useStoreActions();
  const openCopyLinkModal = useOpenCopyLinkModal();
  const {
    copyToClipboard
  } = useIoContext();

  async function getAgreementNotificationLink(agreementId) {
    const notificationId = await api.relationship.getSingleUseApprovalLink(agreementId);
    return "https://".concat(window.location.host).concat(routes.notification(notificationId));
  }

  async function copyNotificationUrl(notificationUrl) {
    try {
      await copyToClipboard(notificationUrl);
      globalContext.showSuccessToast('Link copied to clipboard');
    } catch (e) {
      // e.g. fails if the document loses focus.
      globalContext.showErrorToast('Failed to copy link to clipboard');
    }
  }

  async function copyAgreementLink(agreementId, vendorId, customerId, progressStatus) {
    logBI(10589, {
      vendorId,
      clientId: customerId,
      agreementStatus: progressStatus
    });
    const [url, error, hasError] = await handlePromise(getAgreementNotificationLink(agreementId));

    if (hasError) {
      sendErrReport('failed to copy notification link', error);
      globalContext.showErrorToast('Failed to generate link, please try again', 'agreement-link-error-toast');
      return '';
    }

    await openCopyLinkModal(url, {
      testid: 'copy-direct-link-copy'
    });
    return url;
  }

  return {
    getAgreementNotificationLink,
    copyAgreementLink,
    copyNotificationUrl
  };
}